import React from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle
} from '@ionic/react';
import { DirectionsRenderer, StreetViewPanorama } from 'react-google-maps';
import Map from 'src/components/Map';
import app from 'src/feathers';

class TravelMap extends React.Component {
  state = { directions: null };

  componentDidMount() {
    const travels = this.props.job.stages
      .filter((stage) => stage.type === 'travel')
      .reduce((travels, stage) => {
        return [...travels, stage.origin_address, stage.destination_address];
      }, [])
      .reduce((travels, address, index) => {
        if (travels[index - 1] !== address) {
          travels = [...travels, address];
        }
        return travels;
      }, []);
    app
      .service('google/directions')
      .find({
        query: {
          origin: travels[0],
          destination: travels[travels.length - 1],
          waypoints: travels.slice(1, travels.length - 1).map((address) => {
            return { location: address };
          })
        }
      })
      .then((directions) => this.setState({ directions }));
  }

  render() {
    const { directions } = this.state;
    return (
      <Map height="100%" width="100%">
        {directions && <DirectionsRenderer directions={directions} />}
      </Map>
    );
  }
}

class StreetViewMap extends React.Component {
  state = { location: {}, loaded: false };

  async componentDidMount() {
    const { geometry } = await app
      .service('google/geocode')
      .find({ query: { address: this.props.center } });
    this.setState({ location: geometry.location, loaded: true });
  }

  render() {
    const { location, loaded } = this.state;
    if (!loaded) {
      return null;
    }
    return (
      <Map defaultZoom={15} defaultCenter={location} height="100%" width="100%">
        <StreetViewPanorama defaultPosition={location} visible />
      </Map>
    );
  }
}

const ModalMap = ({ view, center, job }) => {
  if (!view || view === 'travel') {
    return <TravelMap job={job} />;
  } else if (view === 'street' && center) {
    return <StreetViewMap center={center} />;
  } else {
    return <div className="p-5 text-center lead">Invalid Map Request</div>;
  }
};

export default class MapModal extends React.Component {
  // We don't want to mount and draw maps until necessary bc
  // they are heavy DOM and cost us google money. Because
  // IonModal handles so much of the modal mounting lifecyclye
  // we hijack it here to mount/unmount the map even though
  // the modal itself stays mounted.
  // TODO: It would be better if we did not unmount on handleDismiss
  // but bc react-google-maps is a little wonky its easier to just
  // remount when needed.
  state = { mounted: false };
  handleWillPresent = () => this.setState({ mounted: true });
  handleDidDismiss = () => this.setState({ mounted: false });

  render() {
    const { isOpen, onClose, view, center, job, title } = this.props;
    const { mounted } = this.state;
    return (
      <React.Fragment>
        <IonModal
          isOpen={isOpen}
          onWillPresent={this.handleWillPresent}
          onDidDismiss={this.handleDidDismiss}
        >
          <IonHeader translucent>
            <IonToolbar>
              <IonTitle>{title || 'Map'}</IonTitle>
              <IonButtons slot="end">
                <IonButton onclick={onClose && onClose}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div style={{ height: '100%' }}>
              {mounted && <ModalMap job={job} view={view} center={center} />}
            </div>
          </IonContent>
        </IonModal>
      </React.Fragment>
    );
  }
}
